import FantomLogo from '../../assets/images/crosschain/FTM.png'
import AvaxLogo from '../../assets/images/avax-logo.png'
import BSCLogo from '../../assets/images/binance-logo.png'
import EthereumLogo from '../../assets/images/ethereum-logo.png'
import HecoLogo from '../../assets/images/heco-icon.jpg'
import PolkadotLogo from '../../assets/images/polkadot-logo.png'
import PolygonLogo from '../../assets/images/polygon-logo.png'
import MoonriverLogo from '../../assets/images/crosschain/MOVR.png'
import ShidenLogo from '../../assets/images/crosschain/SDN.png'
import IotexLogo from '../../assets/images/crosschain/IOTX.png'
import OneLogo from '../../assets/images/crosschain/ONE.png'
import CroLogo from '../../assets/images/crosschain/CRO.png'
import OkexLogo from '../../assets/images/crosschain/OKT.png'
import MTVLogo from '../../assets/images/crosschain/MTV.png'
import METISLogo from '../../assets/images/crosschain/METIS.png'
import MoonBeamLogo from '../../assets/images/crosschain/GLMR.png'
import ESWLogo from '../../assets/images/crosschain/ESW.svg'
import HTZLogo from '../../assets/images/crosschain/HTZ.png'
import TUSDLogo from '../../assets/images/crosschain/TUSD.png'
import XCADLogo from '../../assets/images/crosschain/XCAD.png'
export const logoByName = {
    FTM: FantomLogo,
    AVAX: AvaxLogo,
    BNB: BSCLogo,
    ETH: EthereumLogo,
    HT: HecoLogo,
    DOT: PolkadotLogo,
    MATIC: PolygonLogo,
    MOVR: MoonriverLogo,
    SDN: ShidenLogo,
    IOTX: IotexLogo,
    ONE: OneLogo,
    CRO: CroLogo,
    OKT: OkexLogo,
    MTV: MTVLogo,
    METIS: METISLogo,
    GLMR: MoonBeamLogo,
    EMISWAP: ESWLogo,
    HTZ: HTZLogo,
    TUSD: TUSDLogo,
    XCAD: XCADLogo,
};
